import React from "react";
import {
    EmailShareButton,
    FacebookShareButton,
    TelegramShareButton,
    TwitterShareButton,
    WhatsappShareButton,

} from "react-share";
import {
    EmailIcon,
    FacebookIcon,
    TelegramIcon,
    TwitterIcon,
    WhatsappIcon,
} from "react-share";
import { primarycolor } from "../Utils/colors";
import { Container } from "@mui/material";

const Sharepopup = ({ name, link }) => {

    return (
       
            <Container style={{ backgroundColor: "white", padding: 20,marginTop:200 }} maxWidth="xs">
                <div style={{ fontWeight: "bold", color: primarycolor, fontFamily: "monospace" }}>{name};</div><br />
                <div>
                    <FacebookShareButton url={link}
                        quote={"Checkout this property.Amazing features awaits"}
                        hashtag={"Eazistey"}>
                        <FacebookIcon style={{ height: 30, width: 30 }} round={true}></FacebookIcon>
                    </FacebookShareButton>&nbsp;&nbsp;
                    <WhatsappShareButton url={link}
                        quote={"Checkout this property.Amazing features awaits"}
                        hashtag={"Eazistey"}>
                        <WhatsappIcon style={{ height: 30, width: 30 }} round={true}></WhatsappIcon>
                    </WhatsappShareButton>&nbsp;&nbsp;
                    <TwitterShareButton url={link}
                        quote={"Checkout this property.Amazing features awaits"}
                        hashtag={"Eazistey"}>
                        <TwitterIcon style={{ height: 30, width: 30 }} round={true}></TwitterIcon>
                    </TwitterShareButton>&nbsp;&nbsp;
                    <TelegramShareButton url={link}
                        quote={"Checkout this property.Amazing features awaits"}
                        hashtag={"Eazistey"}>
                        <TelegramIcon style={{ height: 30, width: 30 }} round={true}></TelegramIcon>
                    </TelegramShareButton>&nbsp;&nbsp;
                    <EmailShareButton url={link}
                        quote={"Checkout this property.Amazing features awaits"}
                        hashtag={"Eazistey"}>
                        <EmailIcon style={{ height: 30, width: 30 }} round={true}></EmailIcon>
                    </EmailShareButton>
                </div>
            </Container>
    )
}

export default Sharepopup;